<template>
  <div class="description-tab">
    <div class="content-section">
      <h2>{{ $t('Apps.appDescriptions') }}</h2>
      
      <div class="description-cards">
        <div class="description-card">
          <div class="info-icon short">
            <span class="material-symbols-outlined">short_text</span>
          </div>
          <div class="info-content">
            <div class="info-label">{{ $t('Apps.shortDescription') }}</div>
            <div class="info-value" v-html="formattedContent(app.appShortDescription) || 'N/A'"></div>
          </div>
        </div>

        <div class="description-card long">
          <div class="info-icon long">
            <span class="material-symbols-outlined">description</span>
          </div>
          <div class="info-content">
            <div class="info-label">{{ $t('Apps.longDescription') }}</div>
            <div class="info-value" v-html="formattedContent(app.appLongDescription) || 'N/A'"></div>
          </div>
        </div>

        <div v-if="!app.appShortDescription && !app.appLongDescription" class="no-description">
          <span class="material-symbols-outlined">description_off</span>
          <p>{{ $t('Apps.noDescription') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formattedContent } from '@/ultis/user/functions/contentFunctions';

export default {
  name: 'DescriptionTab',
  props: {
    app: {
      type: Object,
      required: true
    }
  },
  methods: {
    formattedContent(content) {
      return formattedContent(content);
    }
  }
}
</script>

<style scoped>
.description-tab {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4px;
  overflow-x: hidden;
}

.content-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

h2 {
  font-size: 20px;
  font-weight: 500;
  color: #202124;
  margin-bottom: 24px;
}

.description-cards {
  display: grid;
  gap: 16px;
}

.description-card {
  background: #f8f9fa;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.description-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.description-card.long {
  margin-top: 16px;
}

.info-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-icon .material-symbols-outlined {
  font-size: 24px;
}

.info-icon.short {
  background: #E3F2FD;
  color: #1E88E5;
}

.info-icon.long {
  background: #E8F5E9;
  color: #43A047;
}

.info-label {
  font-size: 14px;
  color: #5f6368;
  margin-bottom: 8px;
}

.info-value {
  font-size: 16px;
  font-weight: 400;
  color: #202124;
  word-break: break-word;
}


.no-description {
  text-align: center;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 16px;
  color: #5f6368;
}

.no-description .material-symbols-outlined {
  font-size: 48px;
  margin-bottom: 16px;
}

.no-description p {
  margin: 0;
  font-size: 16px;
}
</style>